import { Button, Layout, Modal } from "antd";
import { useEffect, useState } from "react";
import Sidebar from "../common/sidebar/Sidebar";
const { Header, Content } = Layout;
import Navbar from "../common/navbar/Navbar";
import "./Layout.scss";
import { Outlet, useNavigate } from "react-router-dom";
import HomeRules from "../pages/HomeRules";

const LayOut = () => {
  const [collapsed, setCollapsed] = useState();
  const [openRules, setOpenRules] = useState(false);
  const [open, setOpen] = useState(false);

  const collll = (val) => {
    setCollapsed(val);
  };

  const toggleDarawer = () => setOpen((prev) => !prev);

  const openDrawer = (val) => {
    setOpen(val);
  };

  const nav = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token") === null) {
      nav("/");
    }
  }, [nav]);

  // Login ke baad sticky body lock / leftover masks hatao taaki menu click kaam kare
  useEffect(() => {
    document.body.style.overflow = "";
    document.body.classList.remove("ant-scrolling-effect");
    // Purana rules popup auto-open band — ye invisible mask se UI freeze karta tha
    localStorage.removeItem("rulesStatus");
    setOpenRules(false);
    return () => {
      document.body.style.overflow = "";
      document.body.classList.remove("ant-scrolling-effect");
    };
  }, []);

  const handleOk = () => {};

  const handleCloseBtn = () => {
    localStorage.removeItem("rulesStatus");
    setOpenRules(false);
    document.body.style.overflow = "";
  };

  return (
    <>
      <Layout className="main_layout">
        <Sidebar collll={collll} open={open} action={toggleDarawer} />
        <Layout>
          <Header
            className="header_com"
            style={{
              padding: 0,
              display: "flex",
              alignItems: "center",
              zIndex: "3",
            }}>
            <Navbar open={open} action={toggleDarawer} />
          </Header>
          <Content className="main_section">
            <Outlet />
          </Content>
        </Layout>
      </Layout>
      <Modal
        open={!!openRules}
        className="modals_rule"
        title="Rules"
        onOk={handleOk}
        onCancel={handleCloseBtn}
        maskClosable
        destroyOnClose
        zIndex={1100}
        footer={[
          <Button key="back" type="primary" onClick={handleCloseBtn}>
            Close
          </Button>,
        ]}>
        <HomeRules />
      </Modal>
    </>
  );
};

export default LayOut;
